//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralTable from '@/components/GeneralTable';
import { log } from 'util';
import checkPermission from '@/utils/permission'; // 权限判断函数

export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      tableName: 't_resource',
      url: {
        getUrl: '/resource',
        method: 'post',
        query: {}
      },
      canSearch: checkPermission('system.resource.list'),
      //true,
      canAdd: checkPermission('system.resource.add'),
      //true,
      canEdit: checkPermission('system.resource.edit'),
      //true,
      canDelete: checkPermission('system.resource.delete'),
      //true,
      canBatchEdit: checkPermission('system.resource.batch'),
      //true,
      canDownload: checkPermission('system.resource.download') //true
    };
  },
  created: function created() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    if (this.$refs.GeneralTable) {
      sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()));
    }
    next();
  },
  methods: {}
};